module.exports = __webpack_public_path__ + "img/facebook.92e6f110.svg";